import { render, staticRenderFns } from "./OriginBreakdownInfoModal.vue?vue&type=template&id=3e1aa52e&scoped=true"
import script from "./OriginBreakdownInfoModal.vue?vue&type=script&lang=js"
export * from "./OriginBreakdownInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1aa52e",
  null
  
)

export default component.exports